import PropTypes from 'prop-types';

// Note: Keep PERMITTED_FEATURES updated to track current features.
const PERMITTED_FEATURES = ['giveaways'];

const FeatureGate = ({ fallbackComponent, featureComponent, flag, userFlags }) => {
  const featureEnabled = userFlags[flag] === true;

  return featureEnabled ? featureComponent : fallbackComponent;
};

export default FeatureGate;

FeatureGate.propTypes = {
  fallbackComponent: PropTypes.element,
  featureComponent: PropTypes.element.isRequired,
  flag: PropTypes.oneOf(PERMITTED_FEATURES).isRequired,
  userFlags: PropTypes.objectOf(PropTypes.bool).isRequired,
};

FeatureGate.defaultProps = { fallbackComponent: null };
